export const experienceData = [
	{
		company: "Barclays",
		position: "Software Developer - Frontend",
		location: "Pune, India",
		startDate: "Apr 2022",
		endDate: "Present",
		description: [
			"Led the development of a data quality dashboard (frontend) for the FML Team. Technologies used - react, redux, and typescript.",
			"Built features like pagination on tables, debounce on error search, accordion on error table, various types of charts, optimized API calls, and others.",
			"Guided and trained colleagues in frontend development in react.",
		],
		codeURL: "",
	},
	{
		company: "Apisero Inc.",
		position: "Software Engineer",
		location: "Pune, India",
		startDate: "Apr 2021",
		endDate: "Mar 2022",
		description: [
			"Designed REST APIs using Mulesoft to interact with the backend server.",
			"Automated the deployment of mule applications by setting up GitLab CI/CD along with GitLab mirroring.",
			"Led the team for a month and received 2 Raving Review Award, and an Ace Award for appreciation from clients and managers.",
		],
		codeURL: "",
	},
	{
		company: "TaiyōAI Inc.",
		position: "Data Engineer",
		location: "Remote",
		startDate: "Oct 2020",
		endDate: "Mar 2021",
		description: [
			"Led a team of 5 and designed and developed a data lake system covering more than 50 data sources using MongoDB, Bigtable, GCS, Python, Flask, Docker, and Compute Engine VMs.",
			"Developed Explainable AI for Time Series Model for GDELT, Civil Unrest in US, Economic Policy Uncertainity and Geopolitical Risk Index.",
		],
		codeURL: "",
	},
	{
		company: "",
		position: "Machine Learning Intern",
		location: "Remote",
		startDate: "Apr 2020",
		endDate: "Sept 2020",
		description: [
			"Worked with Dr. Saurabh Mishra on HAI, Stanford AI Index 2021 research project, we collected and visualized AI conference data providing a unique research analysis and visualization for policymakers.",
		],
		codeURL: "https://github.com/ai-index-hai-stanford/AI-Index-2020",
	},
	{
		company: "Rapidken Technologies Pvt. Ltd.",
		position: "Software Engineer Intern",
		location: "Bangalore, India",
		startDate: "Jun 2020",
		endDate: "Oct 2020",
		description: [
			"Automated about 60 percent of the scripts using Docker, crons and airflow.",
			"Developed the company platform on Linux OS (Ubuntu) and added 40 percent new features to the platform using Python, SQL, and Selenium.",
			"Extracted data through web scraping from 20+ websites using Python libraries such as Scrapy, HTML Parser, and Urllib.",
		],
		codeURL: "",
	},
	{
		company: "Pucho Technology Pvt. Ltd.",
		position: "Deep Learning Intern",
		location: "Bangalore, India",
		startDate: "Jan 2020",
		endDate: "Mar 2020",
		description: [
			"Developed a Speech Emotion Recognition system using MFCC and CNN based classifier.",
		],
		codeURL:
			"https://github.com/sonishreyas/Voice-Emotion-Detection--Pucho-Technologies-",
	},
];
